import { Modal, Button } from "antd";

const FeatureNotAvailableModal = ({
  visible,
  onCancel,
  onUpgrade,
  title = "Upgrade required",
  message,
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onCancel} style={{ marginRight: 8 }}>
            Close
          </Button>
          <Button type="primary" onClick={onUpgrade}>
            Upgrade
          </Button>
        </div>
      }
    >
      <p>
        {message || "This feature is not available with your current plan."}
      </p>
    </Modal>
  );
};

export default FeatureNotAvailableModal;
